var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuyback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.929199,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1C202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 39.1555H33.8667C34.7333 39.1555 35.4533 38.3821 35.4533 37.4488C35.4533 36.2888 35.04 36.0621 34.36 35.8221L33.0133 35.3555V39.1555H33Z",
    fill: "#6C84F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9599 20.4624C24.5999 20.4891 18.6399 26.4758 18.6666 33.8358C18.6933 41.1958 24.6799 47.1558 32.0399 47.1291C39.3999 47.1024 45.3599 41.1158 45.3333 33.7558C45.3066 26.3958 39.3199 20.4491 31.9599 20.4624ZM35.0133 33.9291C36.0533 34.2891 37.4533 35.0624 37.4533 37.4491C37.4533 39.5024 35.8399 41.1558 33.8666 41.1558H32.9999V41.9291C32.9999 42.4758 32.5466 42.9291 31.9999 42.9291C31.4533 42.9291 30.9999 42.4758 30.9999 41.9291V41.1558H30.5199C28.3333 41.1558 26.5599 39.3158 26.5599 37.0491C26.5599 36.5024 27.0133 36.0491 27.5599 36.0491C28.1066 36.0491 28.5599 36.5024 28.5599 37.0491C28.5599 38.2091 29.4399 39.1558 30.5199 39.1558H30.9999V34.6491L28.9866 33.9291C27.9466 33.5691 26.5466 32.7958 26.5466 30.4091C26.5466 28.3558 28.1599 26.7024 30.1333 26.7024H30.9999V25.9291C30.9999 25.3824 31.4533 24.9291 31.9999 24.9291C32.5466 24.9291 32.9999 25.3824 32.9999 25.9291V26.7024H33.4799C35.6666 26.7024 37.4399 28.5424 37.4399 30.8091C37.4399 31.3558 36.9866 31.8091 36.4399 31.8091C35.8933 31.8091 35.4399 31.3558 35.4399 30.8091C35.4399 29.6491 34.5599 28.7024 33.4799 28.7024H32.9999V33.2091L35.0133 33.9291Z",
    fill: "#6C84F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5601 30.4226C28.5601 31.5826 28.9734 31.8093 29.6534 32.0493L31.0001 32.516V28.7026H30.1334C29.2667 28.7026 28.5601 29.476 28.5601 30.4226Z",
    fill: "#6C84F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32.9292C11 21.3372 20.408 11.9292 32 11.9292C43.592 11.9292 50.669 23.6052 50.669 23.6052M50.669 23.6052H45.5M50.669 23.6052V17.9292M53 32.9292C53 44.5212 43.676 53.9292 32 53.9292C17.993 53.9292 11 42.2532 11 42.2532M11 42.2532H15.662M11 42.2532V47.5032",
    stroke: "#6C84F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuyback);
export default __webpack_public_path__ + "static/media/Icon_buyback.9ffd6574061a3dd47f7119f4d52c4b52.svg";
export { ForwardRef as ReactComponent };